// src/components/ui/panels/PanelHeader/PanelHeaderShadcn.jsx
import React from 'react';
import { X } from 'lucide-react';

// shadcn components
import { Button } from '../../button';

import { cn } from '../../../../utils/cn';

const PanelHeaderShadcn = ({
  title,
  subtitle,
  onClose,
  icon: Icon,
  className = '',
  ...props
}) => {
  return (
    <div
      className={cn(
        // Exact header styling from old EventCreationPanel
        "flex flex-row items-center justify-between p-6",
        "bg-gradient-to-r from-slate-800/60 to-slate-900/60",
        "border-b border-slate-700/50 backdrop-blur-xl",
        className
      )}
      {...props}
    >
      {/* Title section */}
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg">
            <Icon className="w-4 h-4 text-white" />
          </div>
        )}
        <div>
          <h2 className="text-xl font-bold text-slate-100">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-slate-400 mt-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Close button */}
      <Button
        variant="ghost"
        onClick={onClose}
        className="p-2 hover:bg-slate-800/50 text-slate-400 hover:text-slate-200 h-auto"
        title="Close"
      >
        <X className="w-5 h-5" />
      </Button>
    </div>
  );
};

export default PanelHeaderShadcn;